import React from "react";
import AnimateHeight from "react-animate-height";

import "./Accordion.css";

class AccordionSectionHeader extends React.Component {
    render() {
      return <div className={`accordion__section__header ${this.props.className}__section__header`}>{this.props.children}</div>;
    }
}
class AccordionSectionBody extends React.Component {
  render() {
    return <div className={`accordion__section__body ${this.props.className}__section__body`}>{this.props.children}</div>;
  }
}


class AccordionSection extends React.Component {
  static Header = AccordionSectionHeader;
  static Body = AccordionSectionBody;

  handleExpand = () => {
    this.props.onExpand(this.props.id);
  }
  handleCollapse = () => {
    this.props.onCollapse(this.props.id);
  }

  render() {
    const bodyHeight = this.props.expanded ? "auto" : "0";
    const expandedClassName = `accordion__section ${this.props.className}__section accordion__section--expanded ${this.props.className}__section--expanded`;
    const collapsedClassName = `accordion__section ${this.props.className}__section accordion__section--collapsed ${this.props.className}__section--collapsed`;
    const className = this.props.expanded ? expandedClassName : collapsedClassName;
    const header = this.props.children.filter(child => child.type === AccordionSectionHeader)[0];
    const body = this.props.children.filter(child => child.type === AccordionSectionBody)[0];

    return (
      <div className={className} onClick={this.props.expanded ? this.handleCollapse : this.handleExpand}>
        {React.cloneElement(header, {className: this.props.className})}
        <AnimateHeight duration={300} height={bodyHeight}>
          { React.cloneElement(body, {className: this.props.className}) }
        </AnimateHeight>
      </div>
    );
  }
}

export default class Accordion extends React.Component {

  static Section = AccordionSection;

  state = {
    expandedIndex: null
  }
  handleChildExpand = (id) => {
    this.setState({
      expandedIndex: id
    })
  }
  handleChildCollapse = (id) => {
    this.setState({
      expandedIndex: null
    })
  }

  render() {
    return (
      <div className={`accordion ${this.props.className}`}>
        { this.props.children.map( (section, index) => {
          const childProps = {
            key: index,
            id: index,
            expanded: this.state.expandedIndex === index,
            onExpand: this.handleChildExpand,
            onCollapse: this.handleChildCollapse,
            className: this.props.className
          }
          return React.cloneElement(section, childProps)
        } )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Accordion.js